import axios from 'axios';

export const SERVER_URL = process.env.REACT_APP_API_URL || '';

export const API_BASE = SERVER_URL ? `${SERVER_URL}/api` : '/api';

export const ENDPOINTS = {
    userRegister: 'User/register',
    userLogin: 'User/login',
    userUpdate: 'User',
    userTokenRefresh: 'User/refresh',
    resources: 'User/resources',
    post: 'Post'
}

export const createEndPoint = (endpoint) => {
    var url = SERVER_URL + 'api/' + endpoint + '/';
    return {
        fetch: () => axios.get(url),
        fetchById: (id) => axios.get(url + id),
        post: (newRecord) => axios.post(url, newRecord),
        put: (id, updatedRecord) => axios.put(id, updatedRecord),
        delete: (id) => axios.delete(url + id)
    }
}

export async function authenticate(username, password) {
    const loginPayload = {
        username: username,
        password: password
    };

    const response = await axios.post(SERVER_URL + 'api/' + ENDPOINTS.userLogin, loginPayload);

    const token = response.data.authToken;
    const refreshToken = response.data.refreshToken;

    return [token, refreshToken];
}

export async function refresh() {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken)
        throw new Error("No refresh token found!");

    const refreshPayload = {
        refreshToken: refreshToken
    };

    const response = await axios.post(SERVER_URL + 'api/' + ENDPOINTS.userTokenRefresh, refreshPayload);
    const authToken = response.data.authToken;
    const newRefreshToken = response.data.refreshToken;

    alert(`Auth Token: ${response.data.authorizationToken}`);
    alert(`Refresh Token: ${response.data.refreshToken}`);

    return [authToken, newRefreshToken];
}

export async function getResources() {
    const headers = withAuth();

    const options = {
        headers: headers
    }

    const response = await axios.get(SERVER_URL + 'api/' + ENDPOINTS.resources);

    const data = response.data;

    return data;
}

function withAuth(headers) {
    const refreshToken = localStorage.getItem('refreshToken');

    if (!refreshToken) {
        // redirect to the login page
        window.location.href = '/login';
        return;
    }

    if (!headers) {
        headers = { };
    }

    headers.Authorization = `Bearer ${refreshToken}`;

    return headers;
}


